import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isFinite from 'lodash/isFinite';
import { defineMessages, injectIntl } from 'react-intl';
import PercentageDataPod from '../../../components/PercentageDataPod';

const messages = defineMessages({
  acceptanceRate: {
    id: 'hubs.admissions.acceptanceRate',
    defaultMessage: 'Acceptance Rate',
  },
  tooltip: {
    id: 'hubs.admissions.acceptanceRate.tooltip',
    defaultMessage:
      'Acceptance rate is determined by comparing the total number of students who applied and total number of students who were accepted in a given year.',
  },
  linkText: {
    id: 'hubs.admissions.acceptanceRate.linktext',
    defaultMessage: 'Check out Scattergrams to see how this relates to you',
  },
});

const AcceptanceRate = ({ acceptanceRate, admissionsTab, lastUpdated, intl }) => {
  const acceptanceRateValue =
    (+get(acceptanceRate, 'applicationsAccepted.value', '') * 100) /
    +get(acceptanceRate, 'applicationsReceived.value', '');
  const title = intl.formatMessage(messages.acceptanceRate);
  const value = Math.floor(acceptanceRateValue);

  return (
    isFinite(acceptanceRateValue) &&
    acceptanceRateValue > 0 && (
      <PercentageDataPod
        header={title}
        footer={lastUpdated}
        tooltip={intl.formatMessage(messages.tooltip)}
        ariaLabel={`${title}, ${value}%`}
        content={{
          values: [
            {
              label: '',
              value,
            },
          ],
          linkText: intl.formatMessage(messages.linkText),
          linkUrl: 'Admissions#scattergrams',
          type: admissionsTab ? 'green' : 'purple',
        }}
      />
    )
  );
};

AcceptanceRate.propTypes = {
  acceptanceRate: PropTypes.object,
  admissionsTab: PropTypes.bool,
  lastUpdated: PropTypes.string,
  intl: PropTypes.object,
};

export default injectIntl(AcceptanceRate);
